export default __webpack_public_path__ + "static/media/img-63.fbd393f4.jpg";